<template>
  <v-dialog :value="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title class="headline accent--text pb-4">Отправка заявления</v-card-title>
      <v-card-text outlined tile class="border-top pb-0 pt-5">
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-alert outlined type="info" text rounded="lg" class="mb-0">
              Прежде чем отправить заявление вам необходмо скачать печатную форму
            </v-alert>
          </v-col>

          <v-col cols="12" class="pb-0">
            <FileInput
              title="Файл документа заявления"
              @set-files="setFiles"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-btn
              small
              outlined
              rounded
              color="success"
              class="white--text px-4 mr-2"
              :loading="printLoading"
              @click="$emit('get-print')"
            >
              <v-icon left small>mdi-check-circle-outline</v-icon>
              Скачать заявление
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn text color="lightGrey" @click="closeConfirmModal">Отмена</v-btn>
        <v-btn
          color="success"
          :loading="loading"
          :disabled="disabledBtn"
          text
          @click="confirm"
        >
          Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FileInput from "@/components/ui/FileInput";

export default {
  name: 'SendApplicationDialog',

  components: {
    FileInput
  },

  props: {
    dialog: Boolean,
    loading: Boolean,
    printLoading: Boolean
  },

  data: () => ({
    filesData: {
      files: [],
      invalid: true
    }
  }),

  computed: {
    disabledBtn() {
      return !this.filesData.files.length || this.filesData.invalid
    }
  },

  methods: {
    setFiles(value) {
      this.filesData = value
    },

    confirm() {
      this.$emit('confirm', this.filesData.files)
    },

    closeConfirmModal() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.theme--light.v-btn.v-btn--disabled {
  color: #dadada !important
}
</style>
